import Rest from '../../app/Base/Rest';

/**
 * @typedef {PerspectiveService}
 */
export default class PerspectiveService extends Rest {
	/**
	 * @type {String}
	 */
	static resource = '/perspective';
}
